import { call, put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import * as actions from '@/actions';
import { GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST, GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST, GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST, GET_TRANSFER_OPTION_REQUEST, TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST, TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST, TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST } from '@/actions/transferline/actionTypes';
import * as apis from '@/apis/transfermobileline';
import { convertAllFilesToDataUrl } from '@/helpers/account';
import navigate from '@/helpers/navigation';
import { TRANSFER_LINE_APPLICATION_DETAIL, TRANSFER_LINE_REQUEST_SUBMIT_PAGE } from '@/config/common';
import { IDownloadTLDocuments, IGetTLDetailInstructions, IGetTransferLineOrder } from '@/actions/transferline/models/types';

export const getTransferLine = (state) => state.transferLine;
export const getDocumentRepo = (state) => state.transferLine.documentRepo;

function* getTransferLineOptions() {
  try {
    const result = yield call(apis.getOptionsForTransfer);
    yield put(actions.getTransferOption.success(result.data));
  } catch (error) {
    yield put(actions.getTransferOption.failure(error));
  }
}

function* getTransferLineDetailInstructions({ reqData }: IGetTLDetailInstructions) {
  try {
    const result = yield call(apis.getSetOfInstructionsForTransfer, reqData);
    yield put(actions.getConversionOfLineDetail.success(result.data));
    if (result.data) {
      yield call(navigate, TRANSFER_LINE_APPLICATION_DETAIL, {});
    }
  } catch (error) {
    yield put(actions.getConversionOfLineDetail.failure(error));
  }
}

function* uploadTransferMobileDocuments({ newFiles, documentName, callback }: any) {
  try {
    const payload = yield convertAllFilesToDataUrl(newFiles, documentName);
    const formData = new FormData();
    const payloadData = payload.map((data) => {
      return {
        fileName: data.fileName,
        documentName: data.documentName
      }
    })
    newFiles.forEach(file => {
      formData.append("files", file);
    });
    formData.append("documentData", JSON.stringify(payloadData));
    const result = yield call(apis.uploadDocuments, formData);
    //const result = yield call(apis.uploadDocuments, payload[0]);
    callback(result.data[0]);
    yield put(actions.uploadTransferLineDocuments.success());
  } catch (error) {
    yield put(actions.uploadTransferLineDocuments.failure(error));
  }
}

function* downloadDocumentTransferMobile({ documentId, callback }: IDownloadTLDocuments) {
  try {
    const documentRepo = yield select(getDocumentRepo);
    const { [documentId]: toDownloadBase64 } = documentRepo;
    if (toDownloadBase64) {
      callback(toDownloadBase64);
    } else {
      const result = yield call(apis.downloadDocumentTransferLine, documentId);
      let downloadData = {}
      if (result) {
        const objLink = URL.createObjectURL(result.data)
        const fileName = result.headers?.['filename'] || '';        // will come from api response header
        downloadData = {
          fileName: fileName,
          link: objLink
        }
      }
      callback(downloadData);
      yield put(actions.downloadDocumentTransferLine.success({ [documentId]: downloadData }));
      // callback(result.data);
      // yield put(actions.downloadDocumentTransferLine.success({ [documentId]: result.data }));
    }
  } catch (error) {
    yield put(actions.downloadDocumentTransferLine.failure(error));
  }
}

function* deleteDocumentTransferMobile({ deleteId, callback }: any) {
  try {
    const documentRepo = yield select(getDocumentRepo);
    const { [deleteId]: toDelete, ...newDocumentRepo } = documentRepo;
    const result = yield call(apis.deleteDocumentTransferLine, deleteId);
    callback(result.data);
    yield put(actions.deleteDocumentTransferLine.success({ documentRepo: newDocumentRepo }));
  } catch (error) {
    yield put(actions.deleteDocumentTransferLine.failure());
  }
}

function* getTransferLineOrder({ reqData }: IGetTransferLineOrder) {
  try {
    const transferlineDetail = yield select(getTransferLine);
    const result = yield call(apis.getTransferLineOrderSubmit, reqData);
    if (result.data?.orderId) {
      const tempTransfereeType = transferlineDetail.transferlineDetail.transferOption.transferTypeTo === 'BRN(within Company A)' ? 'BRN' : transferlineDetail.transferlineDetail.transferOption.transferTypeTo;
      const transferDateInfo = transferlineDetail.transferlineDetail?.dateInformation || []
      const payload = {
        orderId: result.data.orderId,
        transferorType: transferlineDetail.transferlineDetail.transferOption.transferTypeFrom,
        transfereeType: tempTransfereeType,
        tlFormDetails: [...transferlineDetail.transferlineDetail.tlFormDetails, ...transferDateInfo],
        documents: transferlineDetail.transferlineDetail.documents
      }
      const result2 = yield call(apis.getTransferLineRequestFinalSubmit, payload);
      if (result2.data.status === 'Success') {
        yield put(actions.getTransferLineOrder.success(result.data));
        yield call(navigate, TRANSFER_LINE_REQUEST_SUBMIT_PAGE, {});
      }
    }
  } catch (error) {
    yield put(actions.getTransferLineOrder.failure(error));
  }
}

function* getTransferLinePersonalPlans() {
  try {
    const result = yield call(apis.getTransferLinePersonalPlans);
    yield put(actions.getTransferLinePersonalPlans.success(result.data));
  } catch (error) {
    yield put(actions.getTransferLinePersonalPlans.failure(error));
  }
}

export default function* transferLineSagas() {
  yield takeLatest(GET_TRANSFER_OPTION_REQUEST, getTransferLineOptions);
  yield takeLatest(GET_TRANSFER_LINE_DETAIL_INSTRUCTION_REQUEST, getTransferLineDetailInstructions);
  yield takeLatest(TRANSFER_MOBILE_LINE_DOCUMENT_UPLOAD_REQUEST, uploadTransferMobileDocuments);
  yield takeEvery(TRANSFER_MOBILE_LINE_DOCUMENT_DOWNLOAD_REQUEST, downloadDocumentTransferMobile);
  yield takeLatest(TRANSFER_MOBILE_LINE_DOCUMENT_DELETE_REQUEST, deleteDocumentTransferMobile);
  yield takeLatest(GET_TRANSFER_LINE_ORDER_SUBMIT_REQUEST, getTransferLineOrder);
  yield takeLatest(GET_TRANSFER_LINE_PERSONAL_PLANS_REQUEST, getTransferLinePersonalPlans);
}
